import { useElement } from '@carvana/merch-react-hooks';
import { useMemo } from 'react';
import Sections from '~/constants/vdp/sections';
import { useSectionMounted } from '~/context/vdp/UiContext';

function useEventElements() {
  const includePriceDetails = useSectionMounted(Sections.PriceDetails);

  const localElement = useElement('#vdp-events');
  const priceDetailsElement = useElement(
    includePriceDetails ? '#price-details-events' : ''
  );

  return useMemo(
    () => [localElement, priceDetailsElement],
    [localElement, priceDetailsElement]
  );
}

export default useEventElements;
